import { requestApi } from './helper';

export const SAVE_INSTALLATION_ORDERS = 'SAVE_INSTALLATION_ORDERS';
export const SAVE_INSTALLATION_ORDERS_ALL = 'SAVE_INSTALLATION_ORDERS_ALL';

const saveInstallationOrders = (data) => ({
  type: SAVE_INSTALLATION_ORDERS,
  installationOrders: data,
});

const saveInstallationOrdersAll = (data) => ({
  type: SAVE_INSTALLATION_ORDERS_ALL,
  installationOrdersAll: data,
});

export const requestInstallationOrders = (page, limit, jsonObj, errorCallback, callback) => {
  const requestProperties = {
    method: 'POST',
    body: JSON.stringify(jsonObj),
  };
  const path = `/installationdocument/orders?p=${page}&l=${limit}`;
  return requestApi(path, requestProperties, saveInstallationOrders, errorCallback, callback);
};

export const requestInstallationOrdersAll = (jsonObj, errorCallback, callback) => {
  const requestProperties = {
    method: 'POST',
    body: JSON.stringify(jsonObj),
  };
  const path = '/installationdocument/orders/all';
  return requestApi(path, requestProperties, saveInstallationOrdersAll, errorCallback, callback);
};
